export const APP_DETAILS = "APP_DETAILS";

export const BANK_DETAILS = "BANK_DETAILS";
export const BANNERS = "BANNERS";
export const AUTH_MODAL = "AUTH_MODAL";
export const AGENT_CODE = "AGENT_CODE";
export const SEC_LEFT_BAR = "SEC_LEFT_BAR";
